/**
 * email allenwill211@gmail.com
 * Created by allen on 2018/6/30.
 */

import * as React from "react";
import _vj from "video.js";
import "video.js/dist/video-js.css";
import "./style/style.scss";

import { VjsSwitcherList, injectComponent } from "../videoPlayerComtainer/index";
// @ts-ignore
const videojs = window.videojs || _vj;

const defaultEvents = [
  "loadeddata",
  "canplay",
  "canplaythrough",
  "play",
  "pause",
  "waiting",
  "playing",
  "ended",
  "error"
];

export default class VideoPlayer extends React.Component<any, any> {
  private videoDom: any;
  private setVideoDom: any;
  private player: any;

  private globalOption: any = {
    controls: true,
    errorDisplay: false,
    preload: "auto",
    controlBar: {
      remainingTimeDisplay: false,
      playToggle: {},
      progressControl: {},
      fullscreenToggle: {},
      volumeMenuButton: {
        inline: false,
        vertical: true
      }
    },
    techOrder: ["html5"],
    plugins: {}
  };

  constructor(props: any) {
    super(props);
    this.setVideoDom = (element: any) => {
      this.videoDom = element;
    };
  }

  public componentDidMount() {
    const { option } = this.props;

    this.globalOption = Object.assign(this.globalOption, option, { autoplay: true });

    console.log("this.globalOption:::", this.globalOption);
    this.initPlayer();
  }

  public initPlayer() {
    const { sources } = this.props;
    const self: any = this;

    injectComponent(sources);
    const vjsComponent = videojs.getComponent("Component");
    vjsComponent.registerComponent("VjsSwitcherList", VjsSwitcherList);

    this.videoDom.setAttribute("playsinline", true);
    this.videoDom.setAttribute("webkit-playsinline", true);
    this.videoDom.setAttribute("x5-playsinline", true);
    this.videoDom.setAttribute("x5-video-player-type", "h5");
    this.videoDom.setAttribute("x5-video-player-fullscreen", false);

    this.player = videojs(this.videoDom, this.globalOption, function(this: any) {
      const events = defaultEvents.concat(self.props.events || []);
      for (const value of events) {
        this.on(value, () => {
          self.emitPlayerState(value, true);
        });
      }

      this.on("timeupdate", function(this: any) {
        self.emitPlayerState("timeupdate", this.currentTime());
      });
      self.props.ready(this);
    });

    this.player.getChild("controlBar").addChild("VjsSwitcherList", {});
  }

  public emitPlayerState(event: any, value: any) {
    if (event && !!this.props[event]) {
      this.props[event](this.player);
    }
    if (value) {
      this.props.statechanged({ [event]: value });
    }
  }

  public render() {
    return (
      <div className="vjs-custom-skin">
        <video className="video-js" ref={this.setVideoDom} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/videoPlayer/index.tsx